export default "__VITE_ASSET__Dl$B_9q0__"